import Bobines2 from 'assets/img/2-bobines.png';
import Bobines4 from 'assets/img/4-bobines.png';
import Bobines6 from 'assets/img/6-bobines.png';
import Bobines8 from 'assets/img/8-bobines.png';
import PlatBombee from 'assets/img/plat-bombe.png';
import SansPlatBombee from 'assets/img/sans-plat-bombe.png';
import formInputsTypes from '../../simulatorConstant';
import infoMesure from '../infoMesure';

import PoseApplique from 'assets/img/pose-en-applique.png';

import PoseEncastre from 'assets/img/pose-encastre.png';

import PoseTunnel from 'assets/img/pose-en-tunnel.png';

import LameCobra from 'assets/img/lame-cobra.png';
import LameMicroperforee from 'assets/img/lame-micro-perforee.png';
import LamePleine from 'assets/img/lame-pleine.png';
import LamePolycarbonate from 'assets/img/lame-polycarbonate.png';

import RideauAvecCoffre from 'assets/img/rideau-avec-coffre.png';
import RideauSansCoffre from 'assets/img/rideau-sans-coffre.png';



import Axe133 from 'assets/img/axe-133.png';
import Axe168 from 'assets/img/axe-168.png';
import Axe50 from 'assets/img/axe-50.png';
import Axe60 from 'assets/img/axe-60.png';
import Axe76 from 'assets/img/axe-76.png';
import { AxeManuelRM, bobineRM, lamesRM, platBombeRM, PoseRM } from '../data';

const tablierData = {
	id: 'TABLIERRRMCOMPLETData',
	type: formInputsTypes?.SELECT_INPUT,
	label: 'Type de lame',
	name: 'TABLIERRRMCOMPLETData',
	className: 'col-6',
	nextStepData: infoMesure,
	nextStep: false,
	options: lamesRM
};
const type_axe = {
	id: 'AxeMRMData',
	type: formInputsTypes?.SELECT_INPUT,
	label: "Diamètre d'axe",
	name: 'AxeMRMData',
	className: 'col-6',
	nextStepData: tablierData,
	nextStep: false,
	options: AxeManuelRM
};



const Pose = {
	id: 'PoseRM',
	type: formInputsTypes?.SELECT_INPUT,
	label: 'Pose',
	name: 'PoseRM',
	className: 'col-6',
	nextStepData: type_axe,
	nextStep: false,
	options:PoseRM
};

const coffreRM = {
	id: 'coffreRM',
	type: formInputsTypes?.RADIO_INPUT,
	label: 'Coffre',
	name: 'coffreRM',
	className: 'col-6',
	nextStepData: Pose,
	nextStep: false,
	 options: [
	{
		id: 'sansCOFF',
		label: 'Sans coffre',
		value: 'Sans coffre',
		imageUrl: RideauSansCoffre,
		nextStep: false,
		description:
			'- Configuration sans coffre, laissant le mécanisme apparent pour un accès direct et simplifié.',
	},
	{
		id: 'avecCOFF',
		label: 'Avec coffre',
		value: 'Avec coffre',
		imageUrl: RideauAvecCoffre,
		nextStep: false,
		description:
			'- Configuration avec coffre protégeant le mécanisme et améliorant l’esthétique de l’installation.',
	},
],

};

const bobine = {
	id: 'bobines',
	type: formInputsTypes?.SELECT_INPUT,
	label: 'Bobines',
	name: 'bobines',
	className: 'col-6',
	nextStepData: coffreRM,
	nextStep: false,
	options:bobineRM
};

const RideauMetalliqueManuelCompletData = {
	id: 'platBombe',
	type: formInputsTypes?.RADIO_INPUT,
	label: 'Plat bombé',
	name: 'platBombe',
	className: 'col-6',
	nextStepData: bobine,
	nextStep: false,
	options: platBombeRM
};

export default RideauMetalliqueManuelCompletData;
